import styles from "../styles/footer.css";

const Footer = () => {
  return (
    <div className={styles.footerwrapper}>
      <p className={styles.footertitle}>ガリガリ君</p>
    </div>
  );
};

export default Footer;
